export default {
    excess: 'Višak odgovornosti',
    security: 'Sigurnosni depozit',
    fuel_policy: 'Politika goriva',
    like_for_like: 'Isto za isto',
    full_to_full: 'Puno do punog',
    mileage: 'Kilometraža: {mileage} milja po najmu',
    unlimited_mileage: 'Neograničena kilometraža',
    non_refundable: 'Nepovratno',
    free_cancellation_until: 'Besplatno otkazivanje do {date}',
    cancellation_with_terms: 'Otkazivanje {0} u skladu s ',
    t_c_text: 'Uvjeti i odredbe',
    two_free_extras: 'Dva besplatna dodatka pri preuzimanju',
    glass_tyres_covered: 'Stakla i gume su pokriveni',
    spec_fuel_petrol: 'benzin',
    spec_fuel_petrol_diesel: 'benzin/dizel',
};
